module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgB7VS9GYIwFLyHjaWldroBKziBuoDACE7iCIILqBPoBrqB2FHaWuAzL/r5aUgAaWy4Mrm775L3A7R4gaoI/ek6BCMgsM9ATwmuDDopZZJt5/HPxv3pakjsbZSZDzdS0H2cbaPUvPBcpmBv/2kqSUF0MKiap/l1jIWsRZ9H8nzkkYWtX1ZprP/UMK2CvOylcxsrBGgC/tYVjInZRwNI15QaS0uhAUxdMbFUvwFMXTExSfVtQvYJnSUceHZNibFqqcQulER8gQv0rbNO3mCSHIsTR3GX8sWNvbOlDmm2C0YoTyzfcZ8J2TgNXaYy1qZH6a6wTaAhPkkI266osd1WIdAJpL/f200XOFfbLYrR4m94AMriaQ7Q2ovoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/waring.png
// module id = gsat
// module chunks = 1